/* eslint-disable */
export default {
    questionnaire_research_questions_intro: "Before you start your program, we kindly request you to fill in the indicated fields below.\n\nPlease note that the information which you provide below is only used for research purposes.",
    questionnaire_research_questions_title: "Welcome",
    questionnaire_research_questions_save: "Save",
    questionnaire_page_title: "Questionnaire",
    questionnaire_go_back: "Back",
    questionnaire_submit_questionnaire: "Save and to overview",
    questionnaire_next: "Next",
    questionnaire_back: "Back",
    questionnaire_nl_NL: "Nederlands",
    questionnaire_en_GB: "English",
    questionnaire_finish: "Finish",
    questionnaire_start: "Start",
    questionnaire_practice_question: "Practice question",
    questionnaire_example_question: "Example question",
    questionnaire_preparation_practice_questions_show_answer: "Show answer",
    questionnaire_continue: "Continue",
    questionnaire_question: "Question",
    questionnaire_question_required_notification: "NOTE: The question has not been answered. You can only go to the next page if you have answered the question.",
    questionnaire_instruction: "Instruction",
    questionnaire_route_to_overview: "Go to overview",
    questionnaire_could_not_retrieve_questionnaires: "Could not retrieve questionnaires. Please try again later.",
    questionnaire_could_not_retrieve_psession: "Could not retrieve your details. Please try again later.",
    questionnaire_finish_screen_body: "<p>All questions are filled in, thank you for your participation</p><p>You can still go back to the questionnaire and make changes. If you are sure you are completely done, press finish. You will not be able to change your answers once you finish.</p><p><br></p><p><br></p>",
    questionnaire_of: "of",
    questionnaire_correct: "Correct",
    questionnaire_incorrect: "Incorrect",
    questionnaire_maximum_answers_given: "Maximum answers already given",
    questionnaire_dilemma_test_response_intro: "Now indicate how important the considerations were in the choices you made. <br />The considerations are shown on the next screen.",
    questionnaire_de_DE: "German",
    questionnaire_fr_FR: "French",
    questionnaire_no_questionnaires_available: "There are currently no questionnaires available yet. These will be made available at a later stage.",
    questionnaire_update_answer_error: "Something went wrong while saving the answer, please try again later.",
    questionnaire_complete_questionnaire_error: "Something went wrong while completing the questionnaire, please try again later.",
    questionnaire_fetch_questionnaire_error: "Something went wrong while fetching the questionnaire, please try again later.",
    questionnaire_back_to_overview_cancelled: "This questionnaire has been cancelled.",
    questionnaire_back_to_overview_invalidated: "This questionnaire has been invalidated.",
    questionnaire_back_to_overview_finished: "This questionnaire has been completed.",
    questionnaire_return_to_overview_button: "Click here to return to the overview",
    questionnaire_back_to_overview_deadline_exceeded: "The deadline of this questionnaire has exceeded.",
    questionnaire_fetch_questionnaire_intro_error: "Something went wrong while fetching the introduction of the questionnaire, please try again later.",
    questionnaire_finish_screen_finish_button: "Finish",
    questionnaire_return_to_practice_site_button: "Return to the practice site",
    questionnaire_practice_feedback_text_a: "Your score for the practice test:",
    questionnaire_practice_feedback_text_b: "out of",
    questionnaire_practice_verify_answers_error: "Something went wrong while verifying the answers, please try again later.",
    questionnaire_dilemma_test_see_case: "See case",
    questionnaire_answer_options: "Answer options",
    questionnaire_start_questionnaire_error: "Something went wrong while starting the questionnaire, please try again later.",
    questionnaire_dilemma_test_response_intro_case_dialog: "Now indicate how important the considerations were in the choices you made.",
    questionnaire_time_left: "Time left",
    questionnaire_minutes_label: "minutes",
    questionnaire_practice_feedback_question: "Question",
    questionnaire_practice_feedback_correct: "Correct",
    questionnaire_practice_feedback_wrong: "Wrong",
    questionnaire_finish_screen_practice_explanation_flow: "You reviewed all questions, click \"Finish\" to return to the practice site",
    "questionnaire_show explanations_button": "Show explanations",
    questionnaire_not_answered_explanation_flow: "This question was not answered",
    questionnaire_show_explanations_button: "Show explanations"
};
